module.exports = __webpack_public_path__ + "img/table-icon-fb-disabled.5631b4c9.png";